module.exports = __webpack_public_path__ + "img/background032.42b24950.jpg";